import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import HeroCTA from '../components/HeroCTA'
import './ServicesPage.css'

function ServicesPage() {
  useEffect(() => {
    // Handle scrolling to section from hash or sessionStorage
    const scrollToSection = () => {
      const hash = window.location.hash || sessionStorage.getItem('scrollToSection')
      if (hash) {
        const sectionId = hash.replace('#', '')
        const element = document.getElementById(sectionId)
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
            // Clear sessionStorage after scrolling
            sessionStorage.removeItem('scrollToSection')
          }, 100)
        }
      }
    }

    scrollToSection()
  }, [])
  return (
    <div className="services-page">
      <section className="page-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p className="page-hero-subtitle">
            Comprehensive laboratory equipment solutions for businesses and universities
          </p>
        </div>
      </section>

      <section className="services-detail">
        <div className="container">
          <div id="equipment-installation" className="service-detail-card">
            <div className="service-detail-icon">🔧</div>
            <h2>Equipment Installation</h2>
            <p>
              Our expert team provides professional installation services for all types of 
              laboratory equipment. We ensure proper setup, calibration, and testing to 
              guarantee optimal performance from day one.
            </p>
            <ul className="service-benefits">
              <li>Professional installation by certified technicians</li>
              <li>Proper setup and configuration</li>
              <li>Initial calibration and testing</li>
              <li>Compliance with safety standards</li>
              <li>Comprehensive documentation</li>
            </ul>
          </div>

          <div id="calibration-services" className="service-detail-card">
            <div className="service-detail-icon">⚖️</div>
            <h2>Calibration Services</h2>
            <p>
              Precise calibration services to ensure your equipment meets industry standards 
              and regulatory requirements. We provide regular calibration schedules to keep 
              your lab compliant.
            </p>
            <ul className="service-benefits">
              <li>Compliance with regulatory standards</li>
              <li>Regular calibration schedules</li>
              <li>On-site or off-site options</li>
            </ul>
          </div>

          <div id="maintenance-support" className="service-detail-card">
            <div className="service-detail-icon">🛠️</div>
            <h2>Maintenance & Support</h2>
            <p>
              Ongoing maintenance and support to keep your lab equipment running smoothly 
              and efficiently. Prevent downtime with our proactive maintenance programs.
            </p>
            <ul className="service-benefits">
              <li>Preventive maintenance programs</li>
              <li>24/7 emergency support</li>
              <li>Remote diagnostics and troubleshooting</li>
              <li>Parts and supplies management</li>
              <li>Extended warranty options</li>
            </ul>
          </div>

          <div id="consultation-planning" className="service-detail-card">
            <div className="service-detail-icon">📋</div>
            <h2>Consultation & Planning</h2>
            <p>
              Expert consultation to help you plan your lab setup and choose the right 
              equipment for your needs. We work with you to design efficient, compliant 
              laboratory spaces.
            </p>
            <ul className="service-benefits">
              <li>Lab design and layout consultation</li>
              <li>Equipment selection guidance</li>
              <li>Budget planning and optimization</li>
              <li>Compliance and safety assessment</li>
              <li>Project management support</li>
            </ul>
          </div>

          <div className="service-detail-card">
            <div className="service-detail-icon">🎓</div>
            <h2>Training Services</h2>
            <p>
              Comprehensive training programs to ensure your team can safely and effectively 
              operate your laboratory equipment. We offer on-site and remote training options.
            </p>
            <ul className="service-benefits">
              <li>Equipment operation training</li>
              <li>Safety and compliance training</li>
              <li>Maintenance procedures training</li>
              <li>Customized training programs</li>
              <li>Ongoing support and refresher courses</li>
            </ul>
            <div className="service-link">
              <Link to="/training" className="service-link-button">
                Learn More About Training & Consultation →
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="process-section">
        <div className="container">
          <h2>How We Work</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="process-step-number">1</div>
              <h3>Initial Consultation</h3>
              <p>We discuss your needs and requirements in a free consultation call.</p>
            </div>
            <div className="process-step">
              <div className="process-step-number">2</div>
              <h3>Planning & Proposal</h3>
              <p>We create a detailed plan and proposal tailored to your specific needs.</p>
            </div>
            <div className="process-step">
              <div className="process-step-number">3</div>
              <h3>Installation & Setup</h3>
              <p>Our certified technicians install and configure your equipment.</p>
            </div>
            <div className="process-step">
              <div className="process-step-number">4</div>
              <h3>Testing & Calibration</h3>
              <p>We test and calibrate everything to ensure optimal performance.</p>
            </div>
            <div className="process-step">
              <div className="process-step-number">5</div>
              <h3>Training & Support</h3>
              <p>We <Link to="/training">train your team</Link> and provide ongoing support as needed.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-cta-section">
        <div className="container">
          <div className="services-cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Schedule a free consultation to discuss your lab equipment needs.</p>
            <HeroCTA />
          </div>
        </div>
      </section>
    </div>
  )
}

export default ServicesPage
